import * as constants from './constants';

const initialState = {
  allContactTypes: [],
  fetchingLoading: true,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
};

const contactTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CREATE_CONTACT_TYPES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.CREATE_CONTACT_TYPES_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        allContactTypes: [...state.allContactTypes, action.data],
        isAdding: false,
      };
    case constants.CREATE_CONTACT_TYPES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.UPDATE_ORDER_CONTACT_TYPES:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.UPDATE_ORDER_CONTACT_TYPES_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allContactTypes: action.data,
      };
    case constants.UPDATE_ORDER_CONTACT_TYPES_ERROR:
      return {
        ...state,
        fetchingLoading: false,
      };

    case constants.FETCH_CONTACT_TYPES:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_CONTACT_TYPES_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allContactTypes: action.data,
        isAdding: false,
      };
    case constants.FETCH_CONTACT_TYPES_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_CONTACT_TYPES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_CONTACT_TYPES_SUCCESS:
      const updated = state.allContactTypes.map((el) =>
        el._id === action.data._id ? { ...el, ...action.data } : el
      );
      return {
        ...state,
        allContactTypes: updated,
        updateLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_CONTACT_TYPES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_CONTACT_TYPES:
      return {
        ...state,
        updateLoading: true,
        isAdding: false,
      };
    case constants.DELETE_CONTACT_TYPES_SUCCESS:
      const updatedData = state.allContactTypes.filter(
        (el) => el._id !== action.data
      );
      return {
        ...state,
        allContactTypes: updatedData,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_CONTACT_TYPES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };

    default:
      return state;
  }
};

export default contactTypesReducer;
